import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from "mdbreact";
import { Link } from "react-router-dom";
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

const BusinessApproval = (props) => {
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Business Request List", link: "#" },
  ];

  const [businessApprovedList, setBusinessApprovedList] = useState([]);
  const [businessPendingList, setBusinessPendingList] = useState([]);
  const [businessRejectedList, setBusinessRejectedList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("approved");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    onGetBusinessList(page, limit);
    props.setBreadcrumbItems("Business Request List", breadcrumbItems);
  }, [page, limit]);

  function handleRequest(id, requestStatus, btnStatus) {
    if (
      window.confirm(
        `Are you sure you want to ${btnStatus} this business request`
      )
    ) {
      const urlPath = `/business-request`;
      fetch(url.GBN_URL + urlPath, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          businessId: id,
          requestStatus: requestStatus,
        }),
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          if (responseData.status == "success") {
            toast.success(responseData.message);
          }
          onGetBusinessList();
        });
    }
  }

  function onGetBusinessList(pageNo, limit) {
    //setLoading(true);

    const urlPath = `/business-list?page=${pageNo}&limit=${limit}`;

    fetch(url.GBN_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          setBusinessApprovedList(responseData.result.businessApproved);
          setBusinessPendingList(responseData.result.businessPending);
          setBusinessRejectedList(responseData.result.businessRejected);
          setTotalPages(responseData.pagination.totalPages);
          setRows(responseData.result.businessApproved);
        } else {
          console.error("API Error:", responseData.error || "Unknown error");
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  const formattedBusinessApprovedList = businessApprovedList.map(
    (business) => ({
      ...business,
      fullAddress:
        business.city + ", " + business.state + ",  " + business.country,
      SiteUrl: business.website ? (
        <a
          href={
            business.website.startsWith("http")
              ? business.website
              : `https://${business.website}`
          }
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-none text-primary"
        >
          <i className="fas fa-external-link-alt p-1"></i>
        </a>
      ) : (
        "---"
      ),
      Action: [
        <Link
          to={`/BusinessDetails/${business._id}`}
          className="btn btn-info btn-sm me-2"
        >
          {" "}
          <span className="menu-text" style={{ color: "white" }}>
            {" "}
            <span
              className="menu-icon fas fa fa-eye"
              style={{ color: "white" }}
            >
              {" "}
            </span>
          </span>{" "}
        </Link>,
      ],
    })
  );
  const formattedBusinessPendingList = businessPendingList.map((business) => ({
    ...business,
    SiteUrl: business.website ? (
      <a
        href={
          business.website.startsWith("http")
            ? business.website
            : `https://${business.website}`
        }
        target="_blank"
        rel="noopener noreferrer"
        className="text-decoration-none text-primary"
      >
        <i className="fas fa-external-link-alt p-1"></i>
      </a>
    ) : (
      "---"
    ),
    Action: [
      <Link
        to={`/BusinessDetails/${business._id}`}
        className="btn btn-outline-info btn-sm me-2"
      >
        <span className="menu-text">
          <span className="menu-icon fas fa fa-eye"></span>
        </span>
      </Link>,
      <button
        className="btn-sm btn btn-outline-primary me-2"
        onClick={(e) => handleRequest(business._id, "Approved", "approve")}
      >
        <i className="fas fa-check-circle"></i>
      </button>,
      <button
        className="btn-sm btn btn-outline-danger me-2"
        onClick={(e) => handleRequest(business._id, "Rejected", "reject")}
      >
        <i className="fas fa-times-circle "></i>
      </button>,
    ],
  }));
  const formattedBusinessRejectedList = businessRejectedList.map(
    (business) => ({
      ...business,
      fullAddress:
        business.city + ", " + business.state + ",  " + business.country,
      SiteUrl: business.website ? (
        <a
          href={
            business.website.startsWith("http")
              ? business.website
              : `https://${business.website}`
          }
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-none text-primary"
        >
          <i className="fas fa-external-link-alt p-1"></i>
        </a>
      ) : (
        "---"
      ),
      Action: [
        <Link
          to={`/BusinessDetails/${business._id}`}
          className="btn btn-info btn-sm me-2"
        >
          <span className="menu-text" style={{ color: "white" }}>
            <span
              className="menu-icon fas fa fa-eye"
              style={{ color: "white" }}
            ></span>
          </span>
        </Link>,
      ],
    })
  );

  const tableApprovedData = {
    columns: [
      {
        label: "Business Name",
        field: "businessName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Domain",
        field: "domain",
        sort: "asc",
        width: 23,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 10,
      },
      {
        label: "Mobile no.",
        field: "mobileNo",
        sort: "asc",
        width: 10,
      },
      {
        label: "Address",
        field: "fullAddress",
        sort: "asc",
        width: 10,
      },
      {
        label: "Business Type",
        field: "businessType",
        sort: "asc",
        width: 5,
      },
      {
        label: "Site URL",
        field: "SiteUrl",
        sort: "asc",
        width: 5,
      },
    ],
    rows: formattedBusinessApprovedList,
  };
  const tablePendingData = {
    columns: [
      {
        label: "Business Name",
        field: "businessName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 10,
      },
      {
        label: "Mobile no.",
        field: "mobileNo",
        sort: "asc",
        width: 10,
      },
      {
        label: "Site URL",
        field: "SiteUrl",
        sort: "asc",
        width: 5,
      },
      {
        label: "Action",
        field: "Action",
        sort: "asc",
        width: 25,
      },
    ],
    rows: formattedBusinessPendingList,
  };
  const tableRejectedData = {
    columns: [
      {
        label: "Business Name",
        field: "businessName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Domain",
        field: "domain",
        sort: "asc",
        width: 23,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 10,
      },
      {
        label: "Mobile no.",
        field: "mobileNo",
        sort: "asc",
        width: 10,
      },
      {
        label: "Address",
        field: "fullAddress",
        sort: "asc",
        width: 10,
      },
      {
        label: "Business Type",
        field: "businessType",
        sort: "asc",
        width: 5,
      },
      {
        label: "Site URL",
        field: "SiteUrl",
        sort: "asc",
        width: 5,
      },
    ],
    rows: formattedBusinessRejectedList,
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const getPageNumbers = () => {
    const maxPages = 4;
    let start = Math.max(page - 1, 1);
    let end = Math.min(start + maxPages - 1, totalPages);

    if (end - start < maxPages - 1) {
      start = Math.max(end - maxPages + 1, 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="mt-1">
                    <ul className="nav nav-tabs card-header-tabs">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "approved" ? "active fw-bold" : ""}`}
                          onClick={() => handleTabClick("approved")}
                        >
                          <i className="bi bi-house-door me-2"></i> Approved
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "pending" ? "active fw-bold" : ""}`}
                          onClick={() => handleTabClick("pending")}
                        >
                          <i className="bi bi-info-circle me-2"></i> Pending
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "rejected" ? "active fw-bold" : ""}`}
                          onClick={() => handleTabClick("rejected")}
                        >
                          <i className="bi bi-envelope me-2"></i> Rejected
                        </button>
                      </li>
                    </ul>
                    <div className="card-body text-center">
                      {activeTab === "approved" && (
                        <div>
                          <MDBDataTable
                            responsive
                            striped
                            bordered
                            data={tableApprovedData}
                            paging={false}
                          />
                        </div>
                      )}
                      {activeTab === "pending" && (
                        <div>
                          <div className="d-flex justify-content-start mb-2">
                            <span>Show</span>

                            <select
                              className="form-select form-select-sm w-auto mx-2"
                              value={limit}
                              onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset page
                              }}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>

                            <span>entries</span>
                          </div>
                          <MDBDataTable
                            responsive
                            striped
                            bordered
                            data={tablePendingData}
                            paging={false}
                          />
                          <MDBPagination className="justify-content-end">
                            <MDBPageItem disabled={page === 1}>
                              <MDBPageNav onClick={() => setPage(1)}>
                                &laquo;
                              </MDBPageNav>
                            </MDBPageItem>

                            <MDBPageItem disabled={page === 1}>
                              <MDBPageNav onClick={() => setPage(page - 1)}>
                                &lsaquo;
                              </MDBPageNav>
                            </MDBPageItem>

                            {getPageNumbers().map((p) => (
                              <MDBPageItem key={p} active={page === p}>
                                <MDBPageNav onClick={() => setPage(p)}>
                                  {p}
                                </MDBPageNav>
                              </MDBPageItem>
                            ))}

                            <MDBPageItem disabled={page === totalPages}>
                              <MDBPageNav onClick={() => setPage(page + 1)}>
                                &rsaquo;
                              </MDBPageNav>
                            </MDBPageItem>

                            {/* Last */}
                            <MDBPageItem disabled={page === totalPages}>
                              <MDBPageNav onClick={() => setPage(totalPages)}>
                                &raquo;
                              </MDBPageNav>
                            </MDBPageItem>
                          </MDBPagination>
                        </div>
                      )}
                      {activeTab === "rejected" && (
                        <div>
                          <MDBDataTable
                            responsive
                            striped
                            bordered
                            data={tableRejectedData}
                            paging={false}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(BusinessApproval);
